import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, CalendarDays, Dumbbell, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { athleteClient } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const UserMenu = ({ dark }) => {
  const { lang } = useT();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const token = localStorage.getItem("sandlab_athlete_token");

  useEffect(() => {
    if (!token) return;
    athleteClient.get("/training/me").then((r) => setUser(r.data)).catch(() => setUser(null));
  }, [token]);

  if (!token || !user) return null;
  const initials = `${user.name?.[0] || ""}${user.surname?.[0] || ""}`.toUpperCase();
  const logout = () => {
    localStorage.removeItem("sandlab_athlete_token");
    toast.success(lang === "el" ? "Αποσυνδέθηκες" : "Signed out");
    navigate("/training");
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="user-menu-trigger" className={`inline-flex items-center gap-2 rounded-full pl-1 pr-3 py-1 text-sm font-semibold transition-colors ${dark ? "text-slate-800 hover:bg-slate-100" : "text-white hover:bg-white/15"}`}>
          <span className="h-8 w-8 rounded-full bg-sunset text-white text-xs font-black flex items-center justify-center" data-testid="user-avatar">{initials || "?"}</span>
          <span className="hidden sm:inline max-w-[120px] truncate" data-testid="user-menu-name">{user.name}</span>
          <ChevronDown className="h-3.5 w-3.5 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 rounded-2xl" data-testid="user-menu">
        <DropdownMenuLabel className="text-xs text-slate-500">{user.name} {user.surname}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/training")} data-testid="user-menu-training" className="gap-2"><Dumbbell className="h-4 w-4" /> {lang === "el" ? "Προπονήσεις" : "Training"}</DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/courts")} data-testid="user-menu-courts" className="gap-2"><CalendarDays className="h-4 w-4" /> {lang === "el" ? "Κρατήσεις" : "Court booking"}</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout} data-testid="user-menu-logout" className="gap-2 text-rose-600 focus:text-rose-700"><LogOut className="h-4 w-4" /> {lang === "el" ? "Αποσύνδεση" : "Log out"}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
